import { Button, Heading, Paragraph } from '@zillow/constellation';
import type { TourEvent } from '../../../../../../constants';
import { getEventToastDisplayDate } from '../../../../../../utils/formatTime';
import { StyledZIndexModalDialog } from './StyledComponents';

type CancelTourConfirmationModalProps = {
  event: TourEvent;
  onClose: () => void;
  onCancelTourConfirmationClick: () => void;
};
const CancelTourConfirmationModal = ({
  event,
  onClose,
  onCancelTourConfirmationClick,
}: CancelTourConfirmationModalProps) => {
  return (
    <StyledZIndexModalDialog
      isOpen={true}
      renderBody={
        <div data-testid="CancelTourConfirmationModal-Body">
          <Heading level={4} fontFamily="serif" marginBottom="sm">
            Cancel this tour?
          </Heading>
          <Paragraph marginBottom="xs">
            This will let {event.bookedByName} know that the tour scheduled for {getEventToastDisplayDate(event)} is
            canceled.
          </Paragraph>
        </div>
      }
      renderFooter={
        <Button
          buttonType="primary"
          onClick={onCancelTourConfirmationClick}
          data-testid="CancelTourConfirmationModal-CancelBtn"
        >
          Cancel tour
        </Button>
      }
      size={{ default: 'fullScreen', lg: 'md' }}
      onClose={onClose}
      backdrop={null}
    />
  );
};

export default CancelTourConfirmationModal;
